import { z } from 'my-zod'
import { ehsPolarisEmployeeModel } from './ehs-employee-model'

export const ehsEmployeeSystemView = ehsPolarisEmployeeModel
  .pick({
    id: true,
    employeeNumber: true,
    jobFunction: true,
    productGroups: true,
    customerId: true,
    createdDate: true
  })
  .augment({
    departamentName: z.string().nullable(),
    buildingName: z.string()
  })

export type ehsEmployeeSystemView = z.infer<typeof ehsEmployeeSystemView>
